export function setNbsp(text: string) {
  return text.replaceAll('\\u2060', '\u2060').replaceAll('\\u00A0', '\u00A0');
}
